import { TextField } from '@mui/material';
import { Component } from 'react';

export default class MaxContagemInput extends Component {
    render() {
        return (
            <TextField
                {...this.props.props}
                type="number"
                inputProps={{ min: 0 }}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe um valor" : null}
                size="small"
                variant="outlined"
                name="maxcount"
                label={'Núm. máx. de contagem' + (this.props.required ? '*': '')}
                value={this.props.value}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value) : {}} />
        );
    }
}